export const mathStats = {
  cols: ["Statistics", "2016", "2017", "2018"],
  rows: [
    {
      Statistics: "Enrolled Students",
      "2016": 31,
      "2017": 21,
      "2018": 31,
    },
    {
      Statistics: "Volunteers",
      "2016": 17,
      "2017": 17,
      "2018": 20,
    },
    {
      Statistics: "Hours",
      "2016": 290,
      "2017": 328,
      "2018": 434,
    },
    {
      Statistics: "School",
      "2016": 2,
      "2017": 2,
      "2018": 2,
    },
  ],
}
